import env from '@/env';
import { useAtomValue } from 'jotai';
import { navigationTeamIdAtom } from '@/atoms/navigation';

export const TEAM_BASE_ROUTE = `https://${env.VITE_IQ_DOMAIN}/team`;

export const useTeamDashboardNavigation = () => {
  const iqTeamId = useAtomValue(navigationTeamIdAtom);
  const teamRoute = `${TEAM_BASE_ROUTE}/${iqTeamId}`;

  return `${teamRoute}/dashboard`;
};
